// Faixas de CEP dos Correios (5 primeiros dígitos, limite superior) -> UF. O Shopify exige o estado para cotar.
const CEP_UF = [
  [19999, 'SP'], [28999, 'RJ'], [29999, 'ES'], [39999, 'MG'], [48999, 'BA'], [49999, 'SE'], [56999, 'PE'],
  [57999, 'AL'], [58999, 'PB'], [59999, 'RN'], [63999, 'CE'], [64999, 'PI'], [65999, 'MA'], [68899, 'PA'],
  [68999, 'AP'], [69299, 'AM'], [69399, 'RR'], [69899, 'AM'], [69999, 'AC'], [72799, 'DF'], [72999, 'GO'],
  [73699, 'DF'], [76799, 'GO'], [76999, 'RO'], [77999, 'TO'], [78899, 'MT'], [79999, 'MS'], [87999, 'PR'],
  [89999, 'SC'], [99999, 'RS'],
];

function ufDoCep(cep) {
  const n = Number(cep.slice(0, 5));
  if (n < 1000) return null;
  return CEP_UF.find(([max]) => n <= max)[1];
}
window.ufDoCep = ufDoCep; // usado também pela calculadora da página de produto (shipping-calculator.js)

// Teto de frete coberto pelo frete grátis para um carrinho (centavos), ou 0. Espelha frete-gratis-199-cli.mjs.
window.tetoFreteGratis = (totalCentavos) => (totalCentavos >= 19900 && Date.now() < 1794365999000 ? 80 : 0);

const brl = (v) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const esperar = (ms) => new Promise((r) => setTimeout(r, ms));

// CEP calculado nesta página: o carrinho é re-renderizado a cada alteração, então recalcula sozinho.
let ultimoCep = null;

class CartShippingCalculator extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.result = this.querySelector('.cart-shipping-calculator__result');
    try { this.input.value = ultimoCep || localStorage.getItem('cep-frete') || ''; } catch {}

    this.input.addEventListener('input', () => {
      const d = this.input.value.replace(/\D/g, '').slice(0, 8);
      this.input.value = d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
    });
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); this.calcular(); }
    });
    this.querySelector('button').addEventListener('click', () => this.calcular());

    if (ultimoCep) this.calcular();
  }

  async calcular() {
    const cep = this.input.value.replace(/\D/g, '');
    const uf = cep.length === 8 && ufDoCep(cep);
    if (!uf) return this.mostrar('<p>Digite um CEP válido.</p>');

    this.mostrar('<p>Calculando…</p>');
    const qs = new URLSearchParams({
      'shipping_address[zip]': `${cep.slice(0, 5)}-${cep.slice(5)}`,
      'shipping_address[country]': 'Brazil',
      'shipping_address[province]': uf,
    });

    try {
      const prep = await fetch(`${window.Shopify?.routes?.root || '/'}cart/prepare_shipping_rates.json?${qs}`, { method: 'POST', body: '' });
      if (!prep.ok && prep.status !== 202) throw new Error();

      let dados = null;
      for (let i = 0; i < 20 && !dados; i++) {
        const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/async_shipping_rates.json?${qs}`);
        if (r.status === 200) dados = await r.json();
        else if (r.status === 202) await esperar(500);
        else throw new Error();
      }
      if (!dados) throw new Error();

      ultimoCep = this.input.value;
      try { localStorage.setItem('cep-frete', ultimoCep); } catch {}
      this.renderizar(dados.shipping_rates || []);
    } catch {
      this.mostrar('<p>Não foi possível calcular o frete agora. Ele será calculado no checkout.</p>');
    }
  }

  renderizar(fretes) {
    if (!fretes.length) return this.mostrar('<p>Nenhuma opção de entrega para este CEP.</p>');

    const gratis = this.dataset.freteGratis === 'true';
    const teto = Number(this.dataset.teto);
    const itens = fretes
      .sort((a, b) => Number(a.price) - Number(b.price))
      .map((f) => {
        const dias = f.delivery_days?.length ? ` <small>(até ${f.delivery_days[f.delivery_days.length - 1]} dias úteis)</small>` : '';
        const preco = gratis && Number(f.price) <= teto
          ? `<span><s>${brl(f.price)}</s><strong>Grátis</strong></span>`
          : `<span>${Number(f.price) === 0 ? '<strong>Grátis</strong>' : brl(f.price)}</span>`;
        return `<li><span>${f.presentment_name || f.name}${dias}</span>${preco}</li>`;
      })
      .join('');
    this.mostrar(`<ul>${itens}</ul>`);
  }

  mostrar(html) {
    this.result.innerHTML = html;
  }
}

if (!customElements.get('cart-shipping-calculator')) customElements.define('cart-shipping-calculator', CartShippingCalculator);
